import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'secondary' | 'accent' | 'danger' | 'warning' | 'info' | 'success';
  children: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({ 
  variant = 'default', 
  children, 
  className,
  ...props 
}) => {
  const { colors } = useTheme();
  const variantClasses = {
    default: cn(colors.surfaceHover, colors.text),
    secondary: cn(colors.surfaceHover, colors.textSecondary),
    accent: cn(colors.accent, 'text-white'),
    danger: colors.error,
    warning: colors.warning,
    info: colors.info,
    success: colors.success,
  };

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        variantClasses[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
};

export default Badge;
